import { getNestedFormArray, getNestedFormsByTarget } from './apply-nested-forms';
export function applyFormOverrides(form, overrides, recursive) {
  if (recursive === void 0) {
    recursive = true;
  }
  const nestedFormsByTarget = getNestedFormsByTarget(form);
  const fields = (form.fields ?? []).map(field => {
    var _field$view;
    const override = getOverride({
      id: field.id,
      target: field.target,
      overrides
    });
    if (!override) {
      return field;
    }
    if (field.target && field.nestedFormId && recursive) {
      const nestedForm = nestedFormsByTarget == null ? void 0 : nestedFormsByTarget[field.target];
      if (nestedForm) {
        nestedFormsByTarget[field.target] = applyFormOverrides(nestedForm, override, false);
      }
      return {
        ...field,
        ...pick(override, 'hidden'),
        ...pick(override, 'readOnly'),
        view: {
          ...field.view,
          ...pick(override, 'label'),
          ...pick(override, 'disabled')
        },
        validation: {
          ...field.validation,
          ...pick(override, 'required')
        }
      };
    }
    let validation = field.validation;
    let options = {};
    if (Array.isArray(override.countries)) {
      var _validation, _override$countries;
      validation = {
        ...validation,
        string: {
          ...((_validation = validation) == null ? void 0 : _validation.string),
          enum: override.countries
        }
      };
      options = override.countries ? {
        options: (_override$countries = override.countries) == null ? void 0 : _override$countries.map(country => ({
          value: country
        }))
      } : {};
    }
    if (((_field$view = field.view) == null ? void 0 : _field$view.fieldType) === 'MULTILINE_ADDRESS') {
      return applyMultilineAddressOverrides({
        field,
        override: override
      });
    }
    return {
      ...field,
      ...pick(override, 'hidden'),
      ...pick(override, 'readOnly'),
      view: {
        ...field.view,
        ...pick(override, 'label'),
        ...pick(override, 'autocomplete'),
        ...pick(override, 'disabled'),
        ...(override.hasOwnProperty('callingCountryCode') ? {
          defaultCountry: override.callingCountryCode
        } : {}),
        ...options
      },
      validation: {
        ...validation,
        ...pick(override, 'required')
      }
    };
  });
  const nestedForms = nestedFormsByTarget ? getNestedFormArray(nestedFormsByTarget) : undefined;
  return {
    ...form,
    fields,
    ...(nestedForms ? {
      nestedForms
    } : {})
  };
}
function pick(override, key) {
  return override.hasOwnProperty(key) ? {
    [key]: override[key]
  } : {};
}
const getOverride = _ref => {
  let {
    target,
    id,
    overrides
  } = _ref;
  if (target && target in overrides) {
    return overrides[target];
  }
  if (id && id in overrides) {
    return overrides[id];
  }
  return undefined;
};
const applyAddressFieldOverride = (fieldName, override, multilineAddressOptionsFields, multilineAddressFieldSettings) => {
  const fieldOverride = override[fieldName];
  if (!fieldOverride) {
    return {
      multilineAddressOptionsFields,
      multilineAddressFieldSettings
    };
  }
  return {
    multilineAddressOptionsFields: {
      ...multilineAddressOptionsFields,
      ...(fieldOverride.required !== undefined ? {
        [fieldName]: {
          ...(multilineAddressOptionsFields == null ? void 0 : multilineAddressOptionsFields[fieldName]),
          required: fieldOverride.required
        }
      } : {})
    },
    multilineAddressFieldSettings: {
      ...multilineAddressFieldSettings,
      [fieldName]: {
        ...(multilineAddressFieldSettings == null ? void 0 : multilineAddressFieldSettings[fieldName]),
        show: !fieldOverride.hidden
      }
    }
  };
};
const ADDRESS_FIELD_NAMES = ['addressLine', 'addressLine2', 'streetName', 'streetNumber', 'city', 'postalCode', 'subdivision', 'country', 'apartment'];
const applyMultilineAddressOverrides = _ref2 => {
  var _field$validation, _field$view2, _override$addressLine, _override$streetName, _override$country, _override$country2, _override$country3, _field$validation2, _field$validation3, _field$view3, _field$validation4;
  let {
    field,
    override
  } = _ref2;
  const finalState = ADDRESS_FIELD_NAMES.reduce((state, fieldName) => applyAddressFieldOverride(fieldName, override, state.multilineAddressOptionsFields ?? {}, state.multilineAddressFieldSettings ?? {}), {
    multilineAddressOptionsFields: (_field$validation = field.validation) == null || (_field$validation = _field$validation.predefined) == null || (_field$validation = _field$validation.multilineAddressOptions) == null ? void 0 : _field$validation.fields,
    multilineAddressFieldSettings: (_field$view2 = field.view) == null ? void 0 : _field$view2.fieldSettings
  });
  const autocompleteEnabled = (((_override$addressLine = override.addressLine) == null ? void 0 : _override$addressLine.autocomplete) || ((_override$streetName = override.streetName) == null ? void 0 : _override$streetName.autocomplete)) ?? true;
  const allowedCountries = Array.isArray((_override$country = override.country) == null ? void 0 : _override$country.countries) && ((_override$country2 = override.country) == null || (_override$country2 = _override$country2.countries) == null ? void 0 : _override$country2.length) > 0 ? {
    allowedCountries: (_override$country3 = override.country) == null ? void 0 : _override$country3.countries
  } : {};
  const multilineAddressOptions = {
    ...((_field$validation2 = field.validation) == null || (_field$validation2 = _field$validation2.predefined) == null ? void 0 : _field$validation2.multilineAddressOptions),
    fields: {
      ...((_field$validation3 = field.validation) == null || (_field$validation3 = _field$validation3.predefined) == null || (_field$validation3 = _field$validation3.multilineAddressOptions) == null ? void 0 : _field$validation3.fields),
      ...finalState.multilineAddressOptionsFields
    },
    ...allowedCountries
  };
  return {
    ...field,
    view: {
      ...field.view,
      fieldSettings: {
        ...((_field$view3 = field.view) == null ? void 0 : _field$view3.fieldSettings),
        ...finalState.multilineAddressFieldSettings
      },
      autocompleteEnabled
    },
    validation: {
      ...field.validation,
      predefined: {
        ...((_field$validation4 = field.validation) == null ? void 0 : _field$validation4.predefined),
        multilineAddressOptions
      }
    }
  };
};
//# sourceMappingURL=form-overrides.js.map